import ApiService from './fetch.service';

class DocumentService {
    getEmbedDocument(documentId: string) {
        return ApiService.get(`/download/embed/${documentId}`);
    }
}

export default new DocumentService();



// WEBPACK FOOTER //
// ./src/api/document.service.ts